import script from "./TopPlatforms.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPlatforms.vue?vue&type=script&setup=true&lang=js"

import "./TopPlatforms.vue?vue&type=style&index=0&id=02d928de&scoped=true&lang=css"

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d928de"]])

export default __exports__